
import React from "react";
import "./Sublime.css";

// Images
import TopBack from "../assets/top_back.png";
import Star1 from "../assets/icon1.svg";
import Star2 from "../assets/icon2.svg";
import ContainerImage from "../assets/center-image.svg";
import EfficiencyIcon from "../assets/efficiency.svg";
import CommunicationIcon from "../assets/communication.svg";
import SimpleIcon from "../assets/simple.svg";
import CustomizedIcon from "../assets/customized.svg";


const Sublime = () => {
  return (
    <section className="sublime-section">
      {/* Background Gradient */}
      <img src={TopBack} alt="Background" className="background-gradient" />

      {/* Title + Stars */}
      <div className="sublime-header">
        <div className="stars">
          <img src={Star1} alt="Star 1" className="star-icon" />
          <img src={Star2} alt="Star 2" className="star-icon" />
        </div>
        <h2 className="sublime-title">Why Build with Us</h2>
        <p className="sublime-subtitle">
          Rosette Technologies seamlessly integrates with your existing infrastructure,<br />
          allowing you to effortlessly connect and consolidate data from various sources.
        </p>
      </div>

      {/* Middle Section */}
      <div className="sublime-content">
        {/* Left Side */}
        <div className="sublime-side">
          <div className="sublime-feature">
            <img src={EfficiencyIcon} alt="Efficiency" className="feature-icon" />
            <div className="text">
              <h2>Increased Efficiency</h2>
              <p>Our workflows are streamlined, optimised and built to perform.</p>
            </div>
          </div>
          <div className="sublime-feature">
            <img src={CommunicationIcon} alt="Communication" className="feature-icon" />
            <div className="text">
              <h2>Great Communication</h2>
              <p>We’re here for you at any time of the day and would love to hear from you.</p>
            </div>
          </div>
        </div>

        {/* Center Image */}
        <div className="sublime-center">
          
          <img src={ContainerImage} alt="Main Card" className="main-card" />
        </div>

        {/* Right Side */}
        <div className="sublime-side">
          <div className="sublime-feature">
            <img src={SimpleIcon} alt="Simple" className="feature-icon" />
            <div className="text">
              <h2>Smart<br /> Integration</h2>
              <p>Rosette adopts Seamless integration with modern frameworks and techs</p>
            </div>
          </div>
          <div className="sublime-feature">
            <img src={CustomizedIcon} alt="Customized" className="feature-icon" />
            <div className="text">
              <h2>Easily<br /> Customized</h2>
              <p>Need a more custom solution? Done – let’s chat about it.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sublime;

